// Generated file: Do not edit 
// generated from @taqueria-protocol-types
    
import { TaqError, toFutureParseErr, toFutureParseUnknownErr, toParseErr, toParseUnknownErr } from '@taqueria/protocol/TaqError';
import { FutureInstance, resolve, reject } from 'fluture';
import { ZodError } from 'zod';
import { Environment } from '@taqueria/protocol/types';
import { Environment as EnvironmentStrict } from '@taqueria/protocol/out/types-strict';
import { environmentSchema } from '@taqueria/protocol/out/types-zod';

export type { EnvironmentStrict as Environment };

export const from = (input: unknown): EnvironmentStrict => {
	try {
		return environmentSchema.parse(input) as EnvironmentStrict;
	}
	catch (previous: unknown) {
		if (previous instanceof ZodError) {
			const msgs: string[] = previous.errors.reduce(
				(retval, issue) => {
					const path = issue.path.join(' → ');
					const msg = path + ': ' + issue.message;
					return [...retval, msg];
				},
				["Environment is invalid:"],
			);
			const validationErr = msgs.join('\n') + '\n';
			throw toParseErr(previous, validationErr);
		}
		throw toParseUnknownErr(previous, "There was a problem trying to parse a Environment.")
	}
    
};

export const create = (input: Environment): EnvironmentStrict => from(input);

export const of = (input: unknown): FutureInstance<TaqError, EnvironmentStrict> => {
	try {
		return resolve(from(input))
	}
	catch (err){
		return reject(err) as FutureInstance<TaqError, never>
	}
};

export const make = (input: Omit<EnvironmentStrict, '__type'>): FutureInstance<TaqError, EnvironmentStrict> => of(input);

// TEMP: for interoperation with old protocol types during transition
export const schemas = {
	rawSchema: environmentSchema,
	schema: environmentSchema.transform(val => val as EnvironmentStrict),
};
export const rawSchema = schemas.rawSchema;
export const internalSchema = environmentSchema;

export type t = EnvironmentStrict;
        